class FfProductItem extends HTMLElement {
  constructor() {
    super();

    this.productVariants = JSON.parse(this.dataset.variants);
    this.productPrice = this.querySelector(".ff-product-price");
    this.inputFormId = this.querySelector("#ff-button-id");
    this.allLinks = this.querySelectorAll("a");
    this.showMore = this.querySelector(".ff-show-more-variants");
    this.activeVariants;
    this.variantsSelector();
    this.checkAvailability();
    this.showMore && this.showVariantsBox();
  }

  checkAvailability() {
    this.productVariants &&
      this.productVariants.forEach((element) => {
        if (!element.available) {
          const option = this.querySelector(
            '[data-value="' + element.option1 + '"]'
          );
          option && (option.style.textDecoration = "line-through");
          option && (option.dataset.available = element.available);
        }
      });
  }

  variantsSelector() {
    this.variants = this.querySelectorAll(".ff-variant-product");
    this.variants.forEach((data) => {
      data.addEventListener("click", () => {
        if (!data.dataset.available) {
          data.parentNode
            .querySelector(".ff-active-variant")
            .classList.remove("ff-active-variant");
          data.classList.add("ff-active-variant");
          this.activeVariants = this.querySelectorAll(".ff-active-variant");
          let selectedVariant = "";
          if (this.activeVariants.length == 1) {
            selectedVariant = this.productVariants.find(
              (vdata) => vdata.option1 === this.activeVariants[0].dataset.value
            );
          }
          if (this.activeVariants.length == 2) {
            selectedVariant = this.productVariants.find(
              (vdata) =>
                vdata.option1 === this.activeVariants[0].dataset.value &&
                vdata.option2 === this.activeVariants[1].dataset.value
            );
          }
          selectedVariant.price &&
            this.changePrice(String(selectedVariant.price));
          //solo cuando hay imagens destacadas
          selectedVariant.featured_image &&
            this.changesLinks(selectedVariant.id);
          this.changeIdInputForm(selectedVariant.id);
          this.showBuyButton();
        }
      });
    });
  }

  showBuyButton() {
    const sizeVariant = this.querySelector(".ff-color-variant");
    sizeVariant.style.display = "none";
    const productForm = this.querySelector("product-form");
    productForm.style.display = "initial";
    const closeButton = this.querySelector(".ff-show-options");
    closeButton.style.display = "initial";
    this.addCloseEvent(sizeVariant, productForm, closeButton);
  }
  addCloseEvent(sizeVariant, productForm, closeButton) {
    closeButton.addEventListener("click", () => {
      sizeVariant.style.display = "flex";
      productForm.style.display = "none";
      closeButton.style.display = "none";
    });
  }
  changesLinks(id) {
    this.allLinks.forEach((data) => {
      const url = data.href.split("?variant=");
      data.href = `${url[0]}?variant=${id}`;
    });
  }

  changePrice(price) {
    this.productPrice.innerHTML = `${price.slice(0, -2)},${price.slice(-2)}€`;
  }

  changeIdInputForm(id) {
    this.inputFormId && (this.inputFormId.value = id);
  }

  showVariantsBox() {
    const actionElement = this.showMore.querySelector("span");
    const sizeVariant = this.querySelector(".ff-color-variant");
    actionElement.addEventListener("click", () => {
      this.showMore.classList.add("ff-color-variant-hide");
      sizeVariant.classList.remove("ff-color-variant-hide");
    });
  }
}

customElements.define("ff-product-item", FfProductItem);

if (window.matchMedia("(max-width: 990px)")) {
  document.documentElement.style.setProperty(
    "--viewport-height",
    `${window.innerHeight}px`
  );
}
